import * as React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import './side-quote-info.scss';
import OpenLink from '../../assets/images/open-link.svg';
import { useStore } from '../../store';
import { useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';
import { SlideToggle } from '../common/slide-toggle/slide-toggle';

export const SideQuoteInfo = observer(() => {
  const { t } = useTranslation('', { keyPrefix: 'QUOTE_SHORT_INFO' });
  const { signUpStore, quoteStore, shippingInformationStore } = useStore();
  const { quoteShortInfo } = signUpStore;
  const [showInfo, setShowInfo] = useState(false);
  const [isNewShippingHeader, setIsNewShippingHeader] = useState(false);
  const [isNewShippingBody, setIsNewShippingBody] = useState(false);
  const { displayShippingOptions } = quoteStore;
  const { formattedShippingInfo, isNewShippingInfo } = shippingInformationStore;

  const toggle = useCallback(() => {
    const newState = !showInfo;
    if (displayShippingOptions) {
      if (newState) {
        setIsNewShippingHeader(false);
      } else {
        setIsNewShippingBody(false);
      }
    }
    setShowInfo(newState);
  }, [showInfo, displayShippingOptions]);

  useEffect(() => {
    if (!displayShippingOptions) return;

    const isNew = isNewShippingInfo && !!formattedShippingInfo;
    if (!showInfo) {
      setIsNewShippingHeader(isNew);
    }
    setIsNewShippingBody(isNew);
  }, [isNewShippingInfo, formattedShippingInfo, displayShippingOptions]);

  return (
    <>
      {quoteShortInfo && (
        <div className="container-quote-short-info">
          <div className="quote-short-header">
            <div className="d-flex">
              <span>{t('QUOTE', { id: quoteShortInfo.id })}</span>
              {isNewShippingHeader && <span className="circle-header circle-new"></span>}
            </div>
            <div>
              <button type="button" className={classNames('roll-icon', showInfo && 'up')} onClick={toggle}></button>
            </div>
          </div>
          <SlideToggle show={showInfo}>
            <div className="container-toggle-quote-info">
              <div className="quote-short-info">
                <div className="container-readonly">
                  <label>{t('COMPANY_NAME')}</label>
                  <span className="truncate">{quoteShortInfo.customerName}</span>
                </div>
                <hr />
                <div className="container-readonly">
                  <label>{t('ONE_TIME_CHARGES')}</label>
                  <span>{quoteShortInfo.nrc}</span>
                </div>
                {quoteShortInfo.hasPromo && (
                  <div className="container-readonly">
                    <label>
                      {t(quoteShortInfo.promoDuration > 1 ? 'PROMOTIONAL_CHARGES_PLURAL' : 'PROMOTIONAL_CHARGES', {
                        duration: quoteShortInfo.promoDuration,
                      })}
                    </label>
                    <span>{quoteShortInfo.promoMrc}</span>
                  </div>
                )}
                <div className="container-readonly">
                  <label>{t(quoteShortInfo.hasPromo ? 'SUBSEQUENT_CHARGES' : 'RECURRING_CHARGES')}</label>
                  <span>{quoteShortInfo.mrc}</span>
                </div>
                {quoteShortInfo.isUpgrade && (
                  <div className="container-readonly">
                    <label>{t('RECURRING_CHARGES_AFTER_UPGRADE')}</label>
                    <span>{quoteShortInfo.upgradeMrc}</span>
                  </div>
                )}
                {displayShippingOptions && (
                  <div className="container-readonly">
                    <label>
                      {t('SHIPPING_CHARGES')} {isNewShippingBody && <span className="circle-new"></span>}
                    </label>
                    <span>{formattedShippingInfo}</span>
                  </div>
                )}
              </div>
              <div className="container-quote-link">
                <a target="_blank" className="btn-quote-link" href={quoteShortInfo.html}>
                  <img src={OpenLink} title="quote link" alt="quote link" />
                  <span>{t('OPEN_QUOTE')}</span>
                </a>
              </div>
            </div>
          </SlideToggle>
        </div>
      )}
    </>
  );
});
